import { enterpriseApiSlice } from "./index";
import { PaymentSources } from "../Model/paymentObjects";

export const paymentSourceApi = enterpriseApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchPaymentSources: builder.query({
      query: () => ({
        url: "/company/billing/source",
        method: "GET",
      }),
      extraOptions: { auth: true },
      providesTags: ["PaymentSources"],
      transformResponse: (response) => new PaymentSources(response),
    }),
    assignPaymentSource: builder.mutation({
      query: (body) => ({
        url: "/company/billing/source",
        method: "PUT",
        body,
      }),
      extraOptions: { auth: true },
      invalidatesTags: ["PaymentSources"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useFetchPaymentSourcesQuery,
  useAssignPaymentSourceMutation,
} = paymentSourceApi;
